import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import { viewUnitList } from "../../Redux/Actions/unitsActions";
import { addNewAmenities } from "../../Redux/Actions/amenitiesActions";
import AddImage from "../../Global Functions/addImage";
import axios from "axios";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const AddAmenities = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [selectedOption, setSelectedOption] = useState("");

  const [subCategoryList, setSubCategoryList] = useState({});

  const [amenityData, setAmenityData] = useState({
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    category: "",
    project_type: "",
    unit: "",
    amenities_for: "",
    image: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const payloadData = {
      page: 1,
      limit: 1000,
    };
    dispatch(viewCategoryList(payloadData));
    dispatch(viewUnitList(payloadData));
  }, [dispatch]);

  const { categories } = useSelector((state) => state.categories);
  const { units } = useSelector((state) => state.units);

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const { enumsData } = useSelector((state) => state.enumsData);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setAmenityData((prevData) => ({ ...prevData, image: imageUrl }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      let filteredData = { ...amenityData };
      Object.keys(filteredData).forEach((key) => {
        if (filteredData[key] === "" || filteredData[key] === null) {
          delete filteredData[key];
        }
      });

      const response = await dispatch(addNewAmenities(filteredData));

      if (response.statusCode === 200) {
        navigate("/amenities");
      } else {
        return toast.error(response?.message);
      }
      setAmenityData({
        name: "",
        position: Math.floor(Math.random() * 1000) + 1,
        category: "",
        unit: "",
        amenities_for: "",
        image: "",
      });
    } catch (error) {
      return toast.error(error?.message);
    }
  };

  const handleCategoryChange = async (event) => {
    const categoryId = event.target.value;

    setAmenityData((prevData) => ({ ...prevData, project_type: categoryId }));

    // Fetch subcategories
    const subCategoryPayload = {
      page: 1,
      limit: 1000,
      category_id: categoryId,
    };

    const subcategories = await subCategoriesData(subCategoryPayload);
    if (subcategories) {
      setSubCategoryList(subcategories);
    }
  };

  const handleUnitChange = (event) => {
    setAmenityData({ ...amenityData, unit: event.target.value });
  };

  const subCategoriesData = async (subCategoryPayload) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/category/list`,
        subCategoryPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return setSubCategoryList(response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      return null;
    }
  };

  const handleSubCategoryChange = (event) => {
    setAmenityData((prevData) => ({
      ...prevData,
      category: event.target.value, // Update the category with selected subcategory ID
    }));
  };

  return (
    <MainLayout>
      <div
        className="padding-20 bg-white grid-span-5 border-24"
        style={{ width: "100%" }}
      >
        <div>
          <div className="flex-container flex-justify-between align-center">
            <h1>Add Amenity</h1>
            <Link to="/amenities">
              <button className="button-class">View Amenity List</button>
            </Link>
          </div>
          <div>
            <span className="span-class" style={{ borderRadius: "5px" }}>
              Select Amenity For
            </span>
            <select
              value={amenityData.amenities_for}
              onChange={(event) => {
                const value = event.target.value;
                setAmenityData({ ...amenityData, amenities_for: value });
                setSelectedOption(value);
              }}
              className="input-class"
              id=""
              style={{ marginBottom: "20px" }}
            >
              <option selected hidden>
                Select An Option
              </option>
              {enumsData?.data?.AmenityFor &&
                Object.entries(enumsData.data.AmenityFor).map(
                  ([key, value]) => (
                    <option key={key} value={value}>
                      {value.toUpperCase()}
                    </option>
                  )
                )}
            </select>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <SelectInput
                onChange={handleCategoryChange}
                name="project_type"
                value={amenityData.project_type}
                placeholder="Select an Option"
                label="Select Category"
                options={
                  Array.isArray(categories?.data)
                    ? categories.data.map((category) => ({
                        label: category.name,
                        value: category._id,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                onChange={handleSubCategoryChange}
                placeholder="Select an Option"
                label="Select Sub-Category"
                value={amenityData.category}
                options={
                  Array.isArray(subCategoryList?.data)
                    ? subCategoryList.data.map((subCategory) => ({
                        label: subCategory.name,
                        value: subCategory._id,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>

          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Enter Title"
                value={amenityData.name}
                onChange={(event) =>
                  setAmenityData({ ...amenityData, name: event.target.value })
                }
                name="name"
                type="text"
                placeholder="Enter Title"
              ></TextInput>
            </div>
            {selectedOption === "unit" && (
              <div style={{ width: "50%" }}>
                <SelectInput
                  label="Select Unit Type"
                  onChange={handleUnitChange}
                  name="unit"
                  placeholder="Select an Option"
                  options={
                    Array.isArray(units?.data)
                      ? units.data.map((unit) => ({
                          label: unit.name,
                          value: unit._id,
                        }))
                      : []
                  }
                ></SelectInput>
              </div>
            )}
          </div>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class">Add Icon</span>
              <input
                id="image"
                style={{ display: "none" }}
                type="file"
                name="image"
                onChange={(event) => {
                  handleFileChange(event);
                }}
              />

              {/* Custom Button for File Upload */}
              <label for="image" className="label-class-image">
                Click to Upload Icon
              </label>
            </div>
            <div style={{ width: "50%" }}>
              {amenityData?.image ? (
                <div style={{ width: "50px", height: "50px" }}>
                  <img
                    style={{ height: "250%", border: "1px solid #aaa" }}
                    src={amenityData.image}
                    alt=""
                  ></img>
                  <button
                    onClick={() => {
                      setAmenityData((prevData) => ({
                        ...prevData,
                        image: "",
                      }));
                    }}
                  >
                    X
                  </button>
                </div>
              ) : null}
            </div>
          </div>
          <div className="flex-end" style={{ margin: "20px 0px" }}>
            <Link to="/amenities">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button type="submit" className="button-class">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddAmenities;
